/* Nav tile · sits on /division/tdb · CTA to open the Recipe Editor.
 * Shows a quick count of recipes (bases + flavours + decorations). */
import { useEffect, useState } from 'react';
import { ChefHat, ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import api from '@/lib/api';


export default function TDBRecipeEditorTile({ className = '' }) {
  const [counts, setCounts] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const r = await api.get('/tdb-mis/recipes');
        if (!alive) return;
        setCounts({
          base: (r.data.base || []).length,
          flavour: (r.data.flavour || []).length,
          decoration: (r.data.decoration || []).length,
        });
      } catch (e) { /* ignore · tile is non-essential */ }
    })();
    return () => { alive = false; };
  }, []);

  const total = counts ? counts.base + counts.flavour + counts.decoration : null;

  return (
    <button
      data-testid="tdb-recipe-editor-tile"
      onClick={() => navigate('/tdb/recipes')}
      className={`w-full bg-white border border-amber-200 rounded-2xl p-4 text-left hover:bg-amber-50 transition group ${className}`}
    >
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <div className="w-10 h-10 rounded-lg bg-amber-100 text-amber-700 flex items-center justify-center shrink-0">
            <ChefHat className="w-5 h-5" />
          </div>
          <div className="min-w-0">
            <div className="flex items-center gap-2 flex-wrap">
              <h3 className="text-sm font-semibold text-slate-900">Recipe Editor</h3>
              <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-emerald-100 text-emerald-800 font-medium uppercase tracking-wider">
                v2 · Roji approved
              </span>
            </div>
            <p className="text-xs text-slate-500 mt-0.5 truncate">
              {total !== null
                ? `${counts.base} bases · ${counts.flavour} flavours · ${counts.decoration} decoration archetypes`
                : 'Edit base / flavour / decoration recipes · cascade to every SKU'}
              {' · '}rates from master · versioned
            </p>
          </div>
        </div>
        <ChevronRight className="w-4 h-4 text-slate-400 group-hover:text-amber-700 shrink-0" />
      </div>
    </button>
  );
}
